import { render } from "./commonAdsense.vue?vue&type=template&id=2f9afe54&lang=pug"
import script from "./commonAdsense.vue?vue&type=script&lang=js"
export * from "./commonAdsense.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__